import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Eye, EyeOff, Loader2, CheckCircle2 } from "lucide-react";
import { Logo } from "@/components/Brand";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await api.post("/auth/reset-password", { token, new_password: pw }); setDone(true); toast.success("Password updated"); setTimeout(() => navigate("/login"), 1600); }
    catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-140px)] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md bg-white border border-gray-100 rounded-3xl shadow-card p-8">
        <div className="flex justify-center mb-6"><Logo size="text-3xl" /></div>
        {done ? (
          <div className="text-center" data-testid="reset-done">
            <CheckCircle2 className="mx-auto text-green-500" size={40} />
            <h1 className="font-heading font-extrabold text-2xl mt-3">Password updated</h1>
            <p className="text-sm text-muted-foreground mt-1">Taking you to sign in…</p>
          </div>
        ) : !token ? (
          <div className="text-center">
            <h1 className="font-heading font-extrabold text-2xl">Invalid link</h1>
            <p className="text-sm text-muted-foreground mt-1">This reset link is missing or invalid.</p>
            <Link to="/forgot-password" className="inline-block mt-4 bg-metros-red text-white rounded-full px-6 py-3 font-semibold">Request a new link</Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-extrabold text-2xl text-center">Set a new password</h1>
            <p className="text-sm text-muted-foreground text-center mb-6">Choose a strong password you'll remember.</p>
            {err && <div className="bg-red-50 text-metros-red text-sm rounded-xl px-4 py-3 mb-4">{err}</div>}
            <form onSubmit={submit} className="space-y-4">
              <div className="relative">
                <input data-testid="reset-password" type={show ? "text" : "password"} required minLength={6} placeholder="New password (min 6 chars)" value={pw} onChange={(e) => setPw(e.target.value)}
                  className="w-full rounded-xl border border-gray-200 px-4 py-3 pr-11 focus:ring-2 focus:ring-metros-red focus:outline-none" />
                <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button>
              </div>
              <button data-testid="reset-submit" disabled={busy} className="w-full bg-metros-red hover:bg-metros-redhover text-white rounded-full py-3.5 font-bold flex justify-center items-center gap-2 disabled:opacity-60">
                {busy && <Loader2 className="animate-spin" size={18} />} Update Password
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
